import { render, staticRenderFns } from "./ProjectActorDialogShortlist.vue?vue&type=template&id=3bb50f20&scoped=true&"
import script from "./ProjectActorDialogShortlist.vue?vue&type=script&lang=js&"
export * from "./ProjectActorDialogShortlist.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActorDialogShortlist.vue?vue&type=style&index=0&id=3bb50f20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb50f20",
  null
  
)

export default component.exports